import { Flex, FlexProps, useColorModeValue } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Options, Formation as SdFormation } from "sdsvg";
import { Markdown } from "./Markdown";

export const Formation = ({
  content,
  options,
}: {
  content: string;
  options?: Options;
}) => {
  const color = useColorModeValue("#171923", "#ededee");
  const [svg, setSvg] = useState<SVGSVGElement | null>(null);

  const [lastContent, setLastContent] = useState("");
  const [lastColor, setLastColor] = useState("");

  useEffect(() => {
    if (!svg || (content === lastContent && color === lastColor)) return;
    setLastContent(content);
    setLastColor(color);
    const formation = new SdFormation(content, {
      ...options,
      body: { strokeColor: color },
      label: { family: "inherit" },
    });
    svg.innerHTML = "";
    formation.toElement(svg);
    svg.setAttribute("height", svg.viewBox.baseVal.height.toString());
  }, [color, content, lastColor, lastContent, options, svg]);

  return <svg ref={setSvg} />;
};

export const FormationTable = ({
  content,
  options = {},
  ...rest
}: {
  content: [string, string, Options | undefined][];
  options?: Options;
} & FlexProps) => {
  return (
    <Flex
      align="stretch"
      justify="space-evenly"
      flexWrap="wrap"
      gap={3}
      {...rest}
    >
      {content.map(([formation, caption, override], i) => (
        <Flex align="center" justify="center" direction="column" key={i}>
          <Formation
            content={formation}
            options={{ ...options, ...override }}
          />
          <Markdown content={caption} inline={true} />
        </Flex>
      ))}
    </Flex>
  );
};
